var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Group "),_c('em',[_vm._v("users")]),_vm._v(" to efficiently connect them to your IT resources (SSO apps, LDAP resources, networks, and more). ")])
}]

export { render, staticRenderFns }